import styled, { createGlobalStyle } from 'styled-components';

export const GlobalStyle = createGlobalStyle`
  html, body {
    height: 100vh;
  }
`;

export const ModalBaileys = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(250, 250, 250, 0.97);
  display: flex;
  justify-content: center;
  overflow-y: auto;
  z-index: 100;

  & > section {
    position: absolute;
    width: 100%;
    max-width: 700px;
    left: auto;
    top: auto;
    display: flex;
    flex-direction: column;
    row-gap: 10px;
    margin-top: 10%;
    padding-bottom: 30px;
    @media screen and (orientation: portrait) {
      width: 93%;
      margin-top: 15px;
    }
  }
`;

export const BailetsBlock = styled.div`
  width: 100%;
  background: #fff;
  border: 1px solid #eee;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 40px;
  padding-left: 0;
  padding-right: 0;
  box-sizing: border-box;

    & > .closeIcon {
      position: fixed;
      right: 0;
      top: 168px;
      z-index: 1000;
      color: #000;
      cursor: pointer;
      left: 752px;
      margin-left: auto;
      margin-right: auto;
      @media screen and (orientation: portrait) {
        position: absolute;
        right: 11px;
        top: 11px;
        left: auto;
       }
    }

  & .mansion {
    margin-bottom: 40px;
  }

  & > h3 {
    color: #000;
    text-align: center;
    font-size: 36px;
    font-weight: 900;
    padding-bottom: 7px;
    @media screen and (orientation: portrait) {
      font-size: 27px;
    }
  }

  & > h2 {
    color: #000;
    text-align: center;
    font-size: 35px;
    font-weight: 900;
    margin-top: 5px;
    margin-bottom: 5px;
    text-transform: uppercase;
    @media screen and (orientation: portrait) {
      font-size: 20px;
      padding: 6px;
      padding-left: 0;
      padding-right: 0;
      padding-bottom: 0;
      margin: 0;
    }
  }

  & > h4 {
    width: 73%;
    text-align: left;
    margin-bottom: 12px;
    @media screen and (orientation: portrait) {
      width: 90%;
    }
  }

  & > .fullStory {
    position: relative;
    height: 40px;
    border-radius: 50px;
    border: 1px solid #DDD;
    background: rgb(255, 255, 255);
    color: rgb(0, 0, 0);
    text-align: center;
    font-family: Roboto;
    font-size: 11px;
    font-weight: 500;
    letter-spacing: 0.77px;
    text-decoration: none;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
    padding-left: 30px;
    box-sizing: border-box;
    padding-right: 30px;
    margin-bottom: 30px;
    @media screen and (orientation: portrait) {
      margin-bottom: 20px;
      margin-top: 10px;
    }
  }

  & > div {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top: 40px;
    margin-bottom: 40px;
    & > a {
      position: absolute;
      width: 55px;
      height: 55px;
      & > svg {
        position: absolute;
        left: auto;
        top: auto;
        cursor: pointer;
        z-index: 1;
        @media screen and (orientation: portrait) {
          left: auto;
        }
      }
      @media screen and (orientation: portrait) {
        width: 55px;
      }
    }
    @media screen and (orientation: portrait) {
      margin-top: 30px;
    }
  }

  & video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  & img {
    width: 100%;
    height: auto;
  }

  & p {
    color: #333;
    font-family: Roboto;
    font-size: 13px;
    font-weight: 400;
    text-align: justify;
    line-height: 22px;
    letter-spacing: 1.56px;
    margin-top: 25px;
    padding-left: 40px;
    padding-right: 40px;
    box-sizing: border-box;
    @media screen and (orientation: portrait) {
      padding-left: 28px;
      padding-right: 28px;
    }
  }

  & .topPargraph {
    width: 73%;
    padding: 0;
    @media screen and (orientation: portrait) {
      width: 90%;
    }
  }

  & > span {
    color: #000;
    text-align: center;
    font-size: 13px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.52px;
    text-transform: uppercase;
  }

  & > p {
    color: rgba(0, 0, 0, 0.70);
    font-size: 13px;
    font-weight: 400;
    line-height: 22px;
    letter-spacing: 0.52px;
  }
  @media screen and (orientation: portrait) {
    padding: 30px;
    padding-left: 0;
    padding-right: 0;
  }
`;

export const ModalFooter = styled.div`
  position: absolute;
  width: 100%;
  max-width: 900px;
  left: auto;
  bottom: 0;
  padding: 20px;
  padding-bottom: 30px;
  box-sizing: border-box;
  background: #fff;
  display: flex;
  justify-content: center;
`;

export const MenuWrap = styled.div`
  width: 100%;
  display: flex;
  margin-top: 0 !important;
  margin-bottom: 0 !important;
`;
